import { colors } from '@piconetworks/functions'

export default class Paywall {
    static get BUTTON_CSS_CLASS() {
        return 'pico-read-more'
    }

    static buildReadMoreButtonCssDefinition(hex) {
        if (!hex) return
        let css = `.${Paywall.BUTTON_CSS_CLASS} { color: ${colors.getContrastColor(hex)}; background-color: ${hex};
            display: block; margin: 0 auto; }`
        css += `.${Paywall.BUTTON_CSS_CLASS}:hover { background-color: ${colors.getHoverColor(hex)}; }`
        css += `.${Paywall.BUTTON_CSS_CLASS}:active { background-color: ${colors.getActiveColor(hex)}; }`

        const style = document.createElement('style')
        style.type = 'text/css'
        style.appendChild(document.createTextNode(css))

        const headElement = (document.getElementsByTagName('head') || [])[0]
        if (headElement) headElement.appendChild(style)
    }

    static getArticleWrapper(articleWrapperId) {
        return document.getElementById(articleWrapperId)
    }

    constructor({
        breakId = 'pico-break',
        articleWrapperId = 'pico',
        url = window.location.href,
    } = {}) {
        this.articleWrapperId = articleWrapperId
        this.breakId = breakId
        this.linkColor = null

        this.originalArticleWrapper = null
        this.promptType = null
        this.isHidden = false

        this.clientUrl = url
    }

    buildReadMoreButton(readMoreText) {
        const articleWrapper = Paywall.getArticleWrapper(this.articleWrapperId)

        const readMoreWrapper = document.createElement('div')
        readMoreWrapper.setAttribute('id', 'pico-break')

        const readMoreRow = document.createElement('div')
        readMoreRow.setAttribute('class', 'ReadMore')

        const readMoreButton = document.createElement('button')
        readMoreButton.setAttribute('class', Paywall.BUTTON_CSS_CLASS)
        readMoreButton.textContent = readMoreText
        readMoreButton.addEventListener('click', () => window.Pico.handlePromptClick())

        readMoreRow.appendChild(readMoreButton)
        readMoreWrapper.appendChild(readMoreRow)
        articleWrapper.appendChild(readMoreWrapper)
    }

    hideArticle({ style = null, text = null }) {
        try {
            if (!this.originalArticleWrapper || (this.clientUrl !== window.location.href)) {
                const articleWrapper = Paywall.getArticleWrapper(this.articleWrapperId)
                if (!articleWrapper) {
                    throw new Error(`Unable to find article wrapper with id ${this.articleWrapperId}`)
                }

                const articleDirectChildNodes = Array.from(articleWrapper.childNodes)
                const breakElement = document.getElementById(this.breakId)

                // If the Plugin doesn't provide us with an element to chop at, grab the first p tag
                const tagToChop = (!breakElement) ? articleWrapper.querySelector('p') : breakElement.closest(`#${this.articleWrapperId} > *`)
                // eslint-disable-next-line max-len
                const breakIdx = articleDirectChildNodes.findIndex((node) => node === tagToChop) || 0

                this.originalArticleWrapper = articleWrapper.cloneNode(true)

                // eslint-disable-next-line no-plusplus
                for (let i = breakIdx + 1; i < articleDirectChildNodes.length; i++) {
                    articleWrapper.removeChild(articleDirectChildNodes[i])
                }

                Paywall.buildReadMoreButtonCssDefinition(style)
                this.buildReadMoreButton(text)
                this.isHidden = true
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e)
        }
    }

    releaseArticle() {
        if (this.isHidden) {
            // eslint-disable-next-line max-len
            const articleWrapper = Paywall.getArticleWrapper(this.articleWrapperId)

            while (articleWrapper.firstChild) {
                articleWrapper.firstChild.remove()
            }

            const originalChildNodes = Array.from(this.originalArticleWrapper.childNodes)
            originalChildNodes.forEach((node) => articleWrapper.appendChild(node))
            // reset original article wrapper so on logout, it re-locks the article
            this.originalArticleWrapper = null
            this.isHidden = false
        }
    }
}
